import crypto from 'crypto';
import superagent from 'superagent';
import IdTokenVerifier from '../config/pingOIDC_JWT_Verifier';
import cookies from './cookies';

const authorize = async (configPingOIDC) => {
  // initiating pingOIDC
  const authUrl = `${configPingOIDC.authorization_endpoint ||
    configPingOIDC.issuer + '/authorize'}?client_id=${
    configPingOIDC.clientId
  }&redirect_uri=${
    configPingOIDC.redirectUri
  }&response_type=${configPingOIDC.response_type ||
    ''}&prompt=${configPingOIDC.prompt || ''}&scope=${configPingOIDC.scope ||
    ''}&state=${configPingOIDC.state ||
    'a2123a67ff11413fa19217a9ea0fbad5'}&code_challenge=${configPingOIDC.code_challenge ||
    ''}&code_challenge_method=${configPingOIDC.code_challenge_method ||
    ''}&response_mode=${configPingOIDC.response_mode || ''}`;
  window.location.replace(authUrl);
};

const post = (apiPath, headers, body = {}) =>
  new Promise((resolved, rejected) =>
    superagent
      .post(apiPath)
      .send(body)
      .set(headers)
      .end((err, res) => {
        if (err) {
          rejected(res ? res.body : err);
        } else {
          resolved(res.body);
        }
      })
  );

const getAccessToken = async (
  tokenEndpoint,
  clientId,
  code,
  code_verifier,
  redirectUri
) =>
  post(
    `${tokenEndpoint}`,
    { 'Content-Type': 'application/x-www-form-urlencoded' },
    `grant_type=authorization_code&code=${code}&code_verifier=${code_verifier}&client_id=${clientId}&redirect_uri=${redirectUri}`
  );

const base64URLEncode = (str) =>
  str
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

const sha256 = (buffer) =>
  crypto
    .createHash('sha256')
    .update(buffer)
    .digest();

const generatePKCEPair = async () => {
  const code_verifier = base64URLEncode(crypto.randomBytes(32));
  const code_challenge = base64URLEncode(sha256(code_verifier));

  cookies.setCookie('code_verifier', code_verifier);
  cookies.setCookie('code_challenge', code_challenge);

  return { code_verifier, code_challenge };
};

const parseHash = () => {
  return window.location.hash
    .replace('#', '')
    .split('&')
    .reduce((prev, item) => {
      return Object.assign(
        { [item.split('=')[0]]: decodeURIComponent(item.split('=')[1]) },
        prev
      );
    }, {});
};

const verifyIdToken = async (configPingOIDC, options) =>
  IdTokenVerifier(configPingOIDC).verify(configPingOIDC.id_token, {
    ...options,
    audience: configPingOIDC.clientId,
    algorithms: ['RS256'],
  });

const getUserInfo = async (configPingOIDC) => {
  return fetch(
    `${configPingOIDC.userinfo_endpoint ||
      configPingOIDC.issuer + '/userinfo'}`,
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${configPingOIDC.access_token}`,
      },
    }
  ).then((res) => res.json());
};

export default {
  authorize,
  getAccessToken,
  generatePKCEPair,
  parseHash,
  verifyIdToken,
  getUserInfo,
};



// WEBPACK FOOTER //
// ./src/utils/pingOIDC.js